import React from 'react';

export default function FabricCare({ fabricDetails = '', careDetailsList = [], isEyewearProduct }) {
  if (!fabricDetails && careDetailsList?.length === 0) {
    return null;
  }

  return (
    <div className="fabric-care-mfe" data-testid="fabric-care-mfe">
      <div className="fabric-care-mfe__container">
        <h4 className="h4 fabric-care-mfe__label">
          {fabricDetails}
        </h4>
        {careDetailsList?.length > 0 && !isEyewearProduct && (
        <ul className="fabric-care-mfe__list bullet-list">
          {careDetailsList.map((item) => <li key={item.key}>{item.value}</li>)}
        </ul>
        )}
      </div>
    </div>
  );
}
